import { useMemo } from "react";

import type { LeadsColumnTypeDto, LeadsType } from "app/pages/sales-intelligence/modules/leads-search";

import useLeadsSearchResult from "../query/queries/useLeadsSearchResult";

type HookValue = {
    readonly areResultsFetching: boolean;
    readonly areActionsDisabled: boolean;
    readonly numberOfResults: number;
    readonly selectedColumnTypes: readonly LeadsColumnTypeDto[];
};

export const useLeadsResultsActionsState = (leadsType: LeadsType): HookValue => {
    const { data, isFetching } = useLeadsSearchResult(leadsType);

    const selectedColumnTypes = useMemo(() => data?.columns?.map((c) => c.type) ?? [], [data?.columns]);

    return {
        areResultsFetching: isFetching,
        areActionsDisabled: isFetching || !data?.totalCount,
        numberOfResults: data?.totalCount ?? 0,
        selectedColumnTypes,
    };
};
